import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import trackUse from '@utils/trackUse';
import { OptionType } from '@types';
import { logPostHogEvent } from '@utils/index';

const SizeSelect = ({
  options,
  value,
  onChange
}: {
  options: OptionType[];
  value: OptionType;
  onChange: (value: OptionType) => void;
}) => {
  return (
    <>
      {options.length > 0 && (
        <FormControl
          fullWidth
          className=""
          size="small"
          sx={{
            marginTop: '15px'
          }}
        >
          <InputLabel id="filter-size">Filter by size</InputLabel>
          <Select
            labelId="filter-size"
            value={value.value}
            label="Filter by size"
            onChange={(e) => {
              const { value } = e.target;
              // Then get the selected sizeFilter option by value
              const selectedSizeFilterOption = options.filter((option) => {
                return option.value === value;
              })[0];
              trackUse({
                item: 'variations-size-select',
                value: selectedSizeFilterOption.value,
                type: 'SELECT'
              });

              logPostHogEvent('variations-size-select', {
                value: selectedSizeFilterOption.value,
                type: 'SELECT'
              });

              onChange(selectedSizeFilterOption);
            }}
          >
            {options.map((sizeOption) => {
              return (
                <MenuItem
                  key={sizeOption.value}
                  // classes={{ root: classes.selectMenuItemRoot }}
                  value={sizeOption.value}
                >
                  {sizeOption.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default SizeSelect;
